export default __webpack_public_path__ + "static/media/dreadvisage.16a7770d.png";